import Icon from '../components/Icon.vue'

Icon.register({
  'shuttle-van': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M628.9 210.7L494.4 49.3A48-48 0 0 1 457.5 32H32C14.3 32 0 46.3 0 64V352C0 369.7 14.3 384 32 384H64C64 437 107 480 160 480S256 437 256 384H384C384 437 427 480 480 480S576 437 576 384H608C625.7 384 640 369.7 640 352V241.4C640 230.2 636.1 219.3 628.9 210.7zM64 192V96H160V192H64zM160 432C133.5 432 112 410.5 112 384S133.5 336 160 336 208 357.5 208 384 186.5 432 160 432zM320 192H224V96H320V192zM480 432C453.5 432 432 410.5 432 384S453.5 336 480 336 528 357.5 528 384 506.5 432 480 432zM384 192V96H450L530 192H384z'
      }
    ]
  }
})
